export default __webpack_public_path__ + "static/media/gws-finance-logo-white.45d17c2e.svg";